<template>
    <div class="profile_loader">
        <div class="profile_loader_box">
            <div class="profile_loader_avatar shimmer"></div>
            <div class="profile_loader_bubble shimmer"></div>
        </div>
        <div class="profile_loader_follow shimmer"></div>
    </div>
</template>

<script>
export default {
    name: "ProfileLoader"
}
</script>

<style>
.profile_loader {
    width: 100%;
    margin-bottom: 20px;
    background: var(--loader-color);
    border-radius: 20px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
}

.profile_loader_avatar {
    border-radius: 50%;
    width: 98px;
    height: 98px;
    background: rgba(255, 255, 255, 0.1);
}

.profile_loader_follow {
    border-radius: 10px;
    width: 100px;
    height: 32px;
    background: rgba(255, 255, 255, 0.1);
}

.profile_loader_box {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.profile_loader_bubble {
    border-radius: 20px;
    width: 130px;
    height: 40px;
    background: rgba(255, 255, 255, 0.1);
}
</style>